var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFableLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#7567FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0023 23.6825L24.1322 22.5703H20.1489C19.1329 22.5703 18.1577 22.9698 17.4336 23.6825H23.0023Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9252 22.2522L23.0596 10.3076C24.9158 8.48036 27.9254 8.48036 29.7816 10.3076C31.6378 12.1348 31.6378 15.0973 29.7816 16.9245L26.115 20.5337L22.1313 20.5337C20.3626 20.5337 18.6664 21.2253 17.4158 22.4563L15.5493 24.2937L10.9252 28.8455C9.07558 27.0248 9.07558 24.0729 10.9252 22.2522Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4199 28.8769L15.323 26.0192C15.8403 25.51 16.5371 25.2246 17.2629 25.2246H21.3853L19.693 26.8904C18.3998 28.1634 16.6579 28.8769 14.8432 28.8769L12.4199 28.8769Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42871 32.2636L10.9366 28.8105H12.4882L8.98029 32.2636H7.42871Z",
    fill: "#F4F4F4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFableLogo2);
export default __webpack_public_path__ + "static/media/fable-logo-2.4136f79ccee42da4cc675090e72950fa.svg";
export { ForwardRef as ReactComponent };